import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <p>
      Made by <strong>r2d2coder</strong> with love
    </p>
  </footer>
);

export default Footer;
